import api from "../../api/api";
import API_URL from "../../api/url";
import axios from 'axios';

const staffRequest = {
  // categoryList: (page, limit) => api.get(`${API_URL.BASEURL}${API_URL.getCategory}?page=${page}&limit=${limit}`),
  // deleteCategory: (id) => api.post(`${API_URL.BASEURL}${API_URL.deleteCategory}`, id),
  // updateCategory: (values) => api.post(`${API_URL.BASEURL}${API_URL.updateCategory}`, values),
  // categoryDetail: (id) => api.get(`${API_URL.BASEURL}${API_URL.categoryDetail}?id=${id}`),
  // createCategory: (values) => api.post(`${API_URL.BASEURL}${API_URL.createCategory}`, values),
  
  getStaffList : (values) => api.get(`${API_URL.BASEURL}${API_URL.getStaff}`, {
    params: {
      name: values?.name,
      status: values?.status,
      email: values?.email,
      mobile: values?.mobile,
      page: values?.page,
      search: values?.search
    }
  }),
  updateStaff : (values) => api.post(`${API_URL.BASEURL}${API_URL.postUpdateStaff}`,values),
  createStaff : (values) => api.post(`${API_URL.BASEURL}${API_URL.postCreateStaff}`,values),
  staffDetails : (id) => api.get(`${API_URL.BASEURL}${API_URL.getStaffDetails}?staffId=${id}`),
  deleteStaff: (id) => api.post(`${API_URL.BASEURL}${API_URL.postDeleteStaff}?staffId=${id}`),
  logoutStaff : (values) => api.post(`${API_URL.BASEURL}${API_URL.logout}`,values),

  uploadImage: (formData) => {
    const token = localStorage.getItem("accesstoken");
    return api.post(
      `${API_URL.BASEURL}${API_URL.uploadImg}?moduleName=staff`,
      formData,
      {
        headers: {
          token: token ? `${token}` : "",
        },
      }
    );
  }


};



export default staffRequest